import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as GeneralReportService from '../services/generalReportService'
import Currency from './sub_components/currency'

class GeneralReports extends Component {
   constructor(props) {
      super(props);
      this.state = {
         user_id: "",
         user_list: "",
         loader: false,
         userData: ""
      };
   }
   componentDidMount() {
      let userData = localStorage.getItem("userAccData")
      userData = JSON.parse(userData)
      this.setState({ userData: userData, user_id: userData.username },()=>{this.submitForm()})
   }
   parseFilterBody() {
      let body = {
         "user_id": this.state.user_id
      }
      body = this.clean(body);
      return body
   }
   async submitForm() {
      const self = this;
      let body = this.parseFilterBody()
      this.setState({ user_list: [], loader: true })
      await GeneralReportService.postGeneralUserList(body).then((res) => {
         if (res.isSuccess) {
            self.setState(
               {
                  user_list: res.users_list,
               }
            );
         }
         else {
            this.setState({ user_list: [] })
         }
      })
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   render() {
      let index = 1
      let total = this.state.userData.availableBalance
      let downline = 0
      return (
         <div className="bethubs">
            <Header history = {this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <h5 className="text-blue">General Report</h5>
                           <div className="table-responsive">
                              <table id="example" className="table table-striped table-bordered table-sm addpadding">
                                 <thead>
                                    <tr>
                                       <th>Sr.No</th>
                                       <th>Name</th>
                                       <th>Amount</th>
                                       <th>Sr.No</th>
                                       <th>Name</th>
                                       <th>Amount</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                       <tr>
                                          <td>&nbsp;</td>
                                          <td>&nbsp;</td>
                                          <td>&nbsp;</td>
                                          <td>{index}</td>
                                          <td className="text-left">{this.state.userData.username}</td>
                                          <td className="text-right"><Currency key={"general_availbal"} className="fbold d-inline text-success" amount={this.state.userData.availableBalance} showColor={false} /></td>
                                       </tr>
                                    {!!this.state.user_list  && this.state.user_list.map((user,i)=>{                                       
                                       let availableBalance = user.availableBalance
                                       downline += (user.balance - availableBalance)
                                       if(availableBalance !== 0){
                                          index += 1
                                          total += availableBalance
                                       }
                                       return(<>
                                          {availableBalance !== 0 &&
                                             <tr>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>{index}</td>
                                                <td className="text-left">{user.username}</td>
                                                <td className="text-right"><Currency  key={"general_availbal_"+i} className="fbold d-inline text-success" amount={availableBalance} showColor={false} /></td>
                                             </tr>
                                          }
                                       </>)
                                    })}
                                    <tr>
                                       <td>&nbsp;</td>
                                       <td>&nbsp;</td>
                                       <td>&nbsp;</td>
                                       <td>{index + 1}</td>
                                       <td className="text-left">Down Level</td>
                                       <td className="text-right"><span className="fbold text-success">{parseFloat(downline).toFixed(2)}</span></td>
                                    </tr>
                                    <tr>
                                       <td colSpan="6" className="height30"></td>
                                    </tr>
                                    <tr>
                                       <td></td>
                                       <td className="font-weight-bold">Upper Level Total</td>
                                       <td className="text-right font-weight-bold text-red"><span>{parseFloat(-(total + downline)).toFixed(2)}</span></td>
                                       <td></td>
                                       <td className="text-right"></td>
                                       <td className="text-right"></td>
                                    </tr>
                                    <tr>
                                       <td colSpan="6" className="height30"></td>
                                    </tr>
                                    <tr>
                                       <td></td>
                                       <td className="font-weight-bold">General Total</td>
                                       <td className="text-right font-weight-bold text-red"><span>{parseFloat(-(total + downline)).toFixed(2)}</span></td>
                                       <td></td>
                                       <td className="text-right font-weight-bold">General Total</td>
                                       <td className="text-right font-weight-bold text-success"><span>{parseFloat(total + downline).toFixed(2)}</span></td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <Footer />
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(GeneralReports);